/**
 * Endpoint to Strapi (Deployed inside of VPC)
 */
export const STRAPI_API = process.env.STRAPI_API || 'http://strapi-api:1337';

/**
 * Endpoint to API that access to Asura to fetch  (Deployed inside of VPC)
 */
export const STRAPI_CLIENT_API = process.env.STRAPI_CLIENT_API || 'https://strapi-client.getmiso.com/api';
export const ASURA_ENDPOINT = process.env.ASURA_ENDPOINT || 'http://nginx-trusted.asura/trusted/graphql';
export const ASURA_HEADERS = process.env.ASURA_HEADERS;

/**
 * Endpoint to API that access to Asura to fetch  (Publicly accessible)
 */
export const PUBLIC_STRAPI_CLIENT_API =
  process.env.NEXT_PUBLIC_STRAPI_CLIENT_API || 'https://strapi-client.getmiso.com/api';
/**
 * Endpoint to API that aggregates and caches for ServerSideProps (Deployed inside of VPC)
 */
export const AGGREGATE_API = `${STRAPI_CLIENT_API}/aggregate`;

/**
 * Other Keys and Values
 */
export const MIXPANEL_KEY = process.env.NEXT_PUBLIC_MIXPANEL_KEY || '6add5df3a6cd55646ba73bb3a3935298';
export const BRANCH_KEY = process.env.NEXT_PUBLIC_BRANCH_KEY || 'key_test_jgkTZJ8T75XYLriqw5bwaaghqDfR5391';
export const AMPLITUDE_KEY = process.env.NEXT_PUBLIC_AMPLITUDE_KEY || 'f30e8057fefa684a34b82c603901a753';
export const GA4_KEY = process.env.REACT_APP_GA_TRACKING_ID || 'G-3HSVQZTX5Q';

export const CUSTOMER_S3_ENDPOINT = 'https://miso-customer-public.s3.ap-northeast-2.amazonaws.com';

export const SENDBIRD_APP_ID = process.env.NEXT_PUBLIC_SENDBIRD_APP_ID ?? '';

export const LOCAL_HOST = process.env.MISO_LOCAL_HOST || 'https://local-staging.getmiso.com';

export const PAGE_PATH = {
  INTERNET: 'internet',
  INTERNET_ZAPIER: 'internet-1',
  HOMECLEAN: 'homeclean',
  INTERNET_RFQ: 'internet-rfq',
  MOVING: 'moving',
};

export const PAGE_URL = {
  HOMECLEAN: process.env.NEXT_PUBLIC_HC_PAGE_URL || 'https://staging.miso.kr/booking/homeclean',
  INTERNET: process.env.NEXT_PUBLIC_INTERNET_PAGE_URL,
  INTERNET_ZAPIER: `${process.env.NEXT_PUBLIC_INTERNET_PAGE_URL}-1`,
};

export const AMPLITUDE_EVENT = {
  TAP_FLOW_START: 'Web - Tap Flow Start',
  SUBMIT_REQUEST: 'Web - Submit Request',
  CONTINUE_FLOW: 'Web - Continue Flow',
  LINK_CLICK: 'Web - Link Click',
  INTERNET_APPLY_SUBMIT: 'Web - Internet Apply Submit',
  INTERNET_COMPLETE_PAGE_ENTER: 'Web - Internet Complete Page Enter',
  INTERNET_COMPLETE_PAGE_SUBMIT: 'Web - Internet Complete Page Submit',
};

export const MISO_WEB_URL = process.env.NEXT_PUBLIC_MISO_WEB_URL || 'https://staging.getmiso.com';
export const API_V3_URL = process.env.NEXT_PUBLIC_V3_API_URL || 'https://api.staging.getmiso.com/v3';
export const BUILD_MODE = process.env.NEXT_PUBLIC_BUILD_MODE;

export const PORTAL_ELEMENT_ID = {
  PHONE_VERIFIER: 'phone-verifier-portal',
};

export const MISO_APP_STORES = {
  ANDROID: 'https://play.google.com/store/apps/details?id=com.miso&hl=ko-KR',
  IOS: 'https://apps.apple.com/kr/app/%EB%AF%B8%EC%86%8C-200%EA%B0%9C-%ED%99%88%EC%84%9C%EB%B9%84%EC%8A%A4%EA%B0%80-%ED%95%9C-%EA%B3%B3%EC%97%90/id1071778654',
};
